import type { SituationClient } from '../api/clients';

/**
 * Couleurs et libellés d'une situation, en un seul endroit.
 *
 * Même primitive de pastille que le registre (`.spill`) : fond pastel, texte
 * foncé, déclinaison sombre fournie par la feuille de style.
 */
const STYLES: Record<SituationClient, { libelle: string; ton: string }> = {
  'en-cours': { libelle: 'Intervention en cours', ton: 'spill-action' },
  planifiee: { libelle: 'Planifiée', ton: 'spill-info' },
  'sans-suite': { libelle: 'Sans suite planifiée', ton: 'spill-unknown' },
};

export function BadgeSituation({ situation }: { readonly situation: SituationClient }) {
  const style = STYLES[situation];
  return <span className={`spill ${style.ton}`}>{style.libelle}</span>;
}
